import type { StudioContact } from "../components/bliss/StudioContactStart";
import { syncFunnelLeadToSalesInbox } from "./funnelLeadSyncService";

export async function captureStudioLead(
  contact: StudioContact,
  options: { notifyTeam?: boolean } = {},
): Promise<string> {
  const result = await syncFunnelLeadToSalesInbox({
    stage: "funnel_started",
    contact: {
      name: contact.name,
      email: contact.email,
      phone: contact.phone,
      projectZip: contact.zip,
    },
    source: "bliss_design_studio",
    projectContext: { projectZip: contact.zip },
    // Early designer drafts remain quiet; an explicit DayDreamer contact save
    // should notify the team once. Later progress updates are silent in sync.
    skipEmail: options.notifyTeam !== true,
  });
  if (!result.success || !result.quoteRequestId)
    throw new Error("Could not save your contact details. Please try again.");
  return result.quoteRequestId;
}

